/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-30 09:12:58
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-30 09:16:34
 * @FilePath: /wemeet-admin-new/src/hooks/useGlobalConfig.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import { onMounted } from 'vue'
import { getGlobalConfig } from '@/api/global'

export function useGlobalConfig(key, cb) {
  onMounted(() => {
    getGlobalConfig(key).then(({ code, data }) => {
      if (code !== 200) return
      try {
        data = JSON.parse(data.list?.[0].value)
        cb(data)
      } catch (error) {
        console.error(`global config: the "${key}" is load failed`)
      }
    })
  })
}
